import { render, staticRenderFns } from "./DefaultItem.vue?vue&type=template&id=37d762be"
import script from "./DefaultItem.vue?vue&type=script&lang=js"
export * from "./DefaultItem.vue?vue&type=script&lang=js"
import style0 from "./DefaultItem.vue?vue&type=style&index=0&id=37d762be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports